import { render } from "./BtnPrinter.vue?vue&type=template&id=2564f14d"
import script from "./BtnPrinter.vue?vue&type=script&lang=ts"
export * from "./BtnPrinter.vue?vue&type=script&lang=ts"
script.render = render

export default script